var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFloppyDisk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.002,6.77l-2.801-2.8c-0.141-0.141-0.331-0.22-0.53-0.22H4.472c-0.414,0-0.75,0.336-0.75,0.75v15 c0,0.414,0.336,0.75,0.75,0.75h15c0.414,0,0.75-0.336,0.75-0.75V7.3C20.222,7.101,20.143,6.91,20.002,6.77z M9.514,5.25h4.989V8.97 H9.514V5.25z M18.722,18.749h-13.5V5.25h2.792V9.72c0,0.414,0.336,0.75,0.75,0.75h6.489c0.414,0,0.75-0.336,0.75-0.75V5.25h0.357 l2.361,2.361V18.749z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.989,11.732c-1.639,0-2.972,1.333-2.972,2.971s1.333,2.972,2.972,2.972c1.639,0,2.972-1.333,2.972-2.972 S13.628,11.732,11.989,11.732z M11.989,16.175c-0.812,0-1.472-0.66-1.472-1.472s0.66-1.471,1.472-1.471 c0.812,0,1.472,0.659,1.472,1.471S12.801,16.175,11.989,16.175z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppyDisk);
export default __webpack_public_path__ + "static/media/floppy-disk.df982a21c05c3923f17f99b46645b65e.svg";
export { ForwardRef as ReactComponent };